import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useFlow } from '../state/flowStore';
import { CounterText } from '../components/CounterText';

export function AgeRevealScreen() {
  const nav = useNavigate();
  const { scanResult, realAge } = useFlow();
  const [landed, setLanded] = useState(false);

  if (!scanResult) return <Navigate to="/" replace />;

  const skinAge = scanResult.skinAge;
  const gap = skinAge - realAge;
  const isOlder = gap > 0;
  const isYounger = gap < 0;

  const finalColor = isOlder ? 'text-danger' : isYounger ? 'text-success' : 'text-accent';
  const atmosphere = isOlder ? 'bg-danger/10' : isYounger ? 'bg-success/10' : 'bg-accent/10';
  const gapLine = isOlder
    ? `That's ${gap} years older than you should be.`
    : isYounger
    ? `That's ${-gap} years younger than your real age.`
    : `Right on track with your real age.`;
  const subline = isOlder
    ? 'Your skin is aging faster than it has to.'
    : isYounger
    ? "You're doing something right — let's protect it."
    : "There's still room to slow the clock.";

  return (
    <div className="lume-bg min-h-svh relative overflow-hidden flex flex-col items-center justify-center px-6">
      {landed && (
        <div
          className={`absolute pointer-events-none rounded-full blur-3xl ${atmosphere}`}
          style={{ width: 480, height: 480, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />
      )}

      <div className="relative z-10 flex flex-col items-center text-center">
        <span className="lume-eyebrow">YOUR SKIN'S BIOLOGICAL AGE</span>
        <div className="mt-7">
          <CounterText
            target={skinAge}
            onLand={() => setLanded(true)}
            className={landed ? finalColor : ''}
          />
        </div>

        {landed && (
          <div className="mt-6 animate-[fadein_0.5s_ease]">
            <p className={`text-body ${finalColor}`}>{gapLine}</p>
            <p className="text-caption text-text-secondary mt-1.5">{subline}</p>
          </div>
        )}
      </div>

      {landed && (
        <button
          type="button"
          onClick={() => nav('/breakdown')}
          className="absolute bottom-16 inset-x-0 mx-auto text-label text-text-secondary flex items-center justify-center gap-2 animate-[fadein_0.7s_ease]"
        >
          See what's driving this <span aria-hidden>→</span>
        </button>
      )}

      <style>{`@keyframes fadein { from { opacity: 0; transform: translateY(6px) } to { opacity: 1; transform: none } }`}</style>
    </div>
  );
}
